import React from "react";
import useViewMode, { setViewMode, VIEW_LIST, VIEW_GALLERY } from "../utils/viewMode";

// Segmented List / Gallery switch. Rendered only when NSFW mode is on, since the
// gallery is entirely photographs - the caller decides that, not this component.
function ViewModeToggle() {
  const mode = useViewMode();
  const isGallery = mode === VIEW_GALLERY;

  return (
    <div
      className="view-mode-toggle"
      role="group"
      aria-label="Roster display mode"
    >
      <button
        type="button"
        className={`view-mode-toggle__btn${!isGallery ? " is-active" : ""}`}
        onClick={() => setViewMode(VIEW_LIST)}
        aria-pressed={!isGallery}
        title="Show the roster as a list"
      >
        <span aria-hidden="true">☰</span> List
      </button>
      <button
        type="button"
        className={`view-mode-toggle__btn${isGallery ? " is-active" : ""}`}
        onClick={() => setViewMode(VIEW_GALLERY)}
        aria-pressed={isGallery}
        title="Show the roster as a photo gallery"
      >
        <span aria-hidden="true">▦</span> Gallery
      </button>
    </div>
  );
}

export default ViewModeToggle;
